import React, { Component } from "react";
import SubNav from "../../../shared/subnav/SubNav";
import CustomerInfo from "./customerInfo/CustomerInfo";
import styles from "./OrderDetailsNewVersion.module.scss";
import HasPermissionTo from "../../../common/HasPermissionTo";
import PaymentMethod from "./paymentMethod/PaymentMethod";
import CancelOrderDialog from "../CancelOrderDialog";
import ProgressTracker from "./progressTracker/ProgressTracker";
import { withTranslation } from "react-i18next";
import CustomerReservationsClient from "../../../shared/clients/CustomerReservationsClient";
import { logMsg } from "../../../common/Logger";
import TradeIn from "../../tradeIn/TradeIn";
import WallBoxDetails from "./wallBoxDetails/WallBoxDetails";
import UpperCaseText from "../../../utils/UpperCaseText";
import {
  APPROVED,
  COMMERCIAL_SEGMENT,
  FINANCE,
  PRIVATE_LEASE,
} from "../../../common/Constants";
import CustomerOptOffline from "./customerOptOffline/CustomerOptOffline";
import OrderDetailsActionNotifications from "./orderDetailsActionNotifications/OrderDetailsActionNotifications";
import OrderInfo from "./orderInfo/OrderInfo";
import VehicleSpecs from "./vehicleSpecs/VehicleSpecs";
import HandOver from "./handOver/HandOver";
import PaymentDetails from "../orderDetailsNewVersion/paymentDetails/paymentDetails";
import DealerInformation from "../orderDetailsNewVersion/dealerInformation/DealerInformation";
import ErrorProcessingDialog from "../../../errors/ErrorProcessingDialog";
import { HANDOVER_STATUS } from "./handOver/Constants";
import {
  AGENT,
  DEALER,
  IS_GERMAN_MARKET,
  NULL_OR_UNDEFINED,
} from "../../../utils/EmpUtil";
import VehicleSpecsHercules from "./vehicleSpecs/VehicleSpecsHercules";
import { formatEUPriceValue } from "../../../utils/FormatPrice";
import LowerCaseText from "../../../utils/LowerCaseText";
import CvVehicleSpecsHercules from "./vehicleSpecs/CvVehicleSpecsHercules";
import OrderNotificationsClient from "../../../shared/clients/OrderNotificationsClient";
import BackToSearchResults from "./backToSearchResults/backToSearchResults";

class OrderDetailsNewVersion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerReservationDetails: null,
      appraisalAmount: null,
      outstandingFinance: null,
      isLoading: true,
      openCancelDialog: false,
      fetchFailed: false,
      openErrorDialog: false,
      cancellationMessage: {
        title: "",
        body: "",
      },
      latestOrderUpdateNotifications: null,
    };
    this.dialogProps = {
      title: this.props.t("CustomerOrderDetails.confirmDialogTitle"),
      body: this.props.t("CustomerOrderDetails.bodyText"),
      checkbox: this.props.t("CustomerOrderDetails.checkBoxText"),
      checkboxList: [],
      cancel: this.props.t("CustomerOrderDetails.goBack"),
      confirm: this.props.t("CustomerOrderDetails.cancelBtnTxt"),
    };

    this.preOrderPlacedStatuses = [
      "CREATED",
      "AMENDED",
      "RESERVATION_FAILED",
      "ORDER_RESERVED",
      "ORDER_CONTRACTED",
      "CONTRACT_REQUESTED",
      "CONTRACT_REQUEST_FAILED",
      "CONTRACT_FAILED",
      "CONTRACT_CANCEL_REQUESTED",
      "CONTRACT_CANCEL_REQUEST_FAILED",
      "CONTRACT_CANCEL_FAILED",
      "RESERVATION_CANCELLATION_FAILED",
      "AMEND_CONTRACT_REQUEST_FAILED",
      "AMEND_CONTRACT_CANCEL_REQUEST_FAILED",
    ];

    this.fetchCustomerOrderDetails = this.fetchCustomerOrderDetails.bind(this);

    this.userAgentHercules =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "herculesPricingStack"
      );
    this.herculesCanViewDealerType =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "herculesCanViewDealerType"
      );
  }

  componentDidMount() {
    this.fetchCustomerOrderDetails();
    this.fetchLatestOrderUpdateNotifications(
      this.props.user,
      this.props.reservationId
    );
  }

  handleUpdatePaymentMethod = (paymentMethod, date) => {
    const paymentUpdate = {
      commonId: this.props.commonId,
      orderId: this.props.reservationId,
      financeProductType: paymentMethod,
      statusUpdatedTime: date,
      triggeredUser: this.props.user.userId,
    };

    this.props.hideOrShow(true);
    CustomerReservationsClient.updatePaymentMethod(
      this.props.token,
      paymentUpdate
    )
      .then(() => {
        this.fetchCustomerOrderDetails();
      })
      .catch(() =>
        this.setState({
          cancellationMessage: {
            title: this.props.t("Error.processingErrorTitle"),
            body: this.props.t("Error.processingErrorMessage"),
          },
          openErrorDialog: true,
        })
      )
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  handleUpdateOrder = (dealerAction, acceptedDate, cancelReason) => {
    this.props.hideOrShow(true);

    const dealerActionInfo = {
      reservationId: this.props.reservationId,
      dealerAction: dealerAction,
      acceptedDate: acceptedDate,
      dealerRejectedReason: cancelReason,
    };

    CustomerReservationsClient.updateOrder(
      this.props.token,
      this.props.commonId,
      dealerActionInfo,
      this.props.user.userId
    )
      .then(() => {
        this.setState({ openCancelDialog: false });
        this.fetchCustomerOrderDetails();
      })
      .catch((error) => {
        logMsg("the error is: ", error);

        const errorCodes = [
          "ORDER_CANCELLED",
          "ORDER_CANCELLED_REFUND_FAILED",
          "ORDER_CANCELLED_REFUND_SUCCESS",
        ]; // error codes that error dialog is display for

        // error message detail that is returned by the backend service with bad request (400 error)
        const errorDetail =
          error.response &&
          error.response.data &&
          error.response.data.status &&
          error.response.data.status === 400 &&
          error.response.data.message &&
          JSON.parse(error.response.data.message).errors[0];

        const errorMessage =
          errorDetail &&
          errorDetail.message &&
          errorCodes.some(
            (err) =>
              errorDetail.errorCode && errorDetail.errorCode.includes(err)
          ) &&
          errorDetail;

        if (errorMessage) {
          if (errorDetail.errorCode === "ORDER_CANCELLED") {
            errorMessage.message = "Error.refundFailure"; //1000
          }

          if (errorDetail.errorCode === "ORDER_CANCELLED_REFUND_FAILED") {
            errorMessage.message = "Error.refundFailure"; //1000
          }

          if (errorDetail.errorCode === "ORDER_CANCELLED_REFUND_SUCCESS") {
            errorMessage.message = "Error.failedCancellationAndRefund"; //1001
          }
        }

        this.setState({
          openCancelDialog: false,
        });

        errorMessage
          ? this.setState({
              cancellationMessage: {
                title: this.props.t("Error.TitleSAP-FORDPAY400"),
                body: this.props.t(errorMessage.message),
              },
              openErrorDialog: true,
            })
          : this.setState({
              cancellationMessage: {
                title: this.props.t("Error.processingErrorTitle"),
                body: this.props.t("Error.processingErrorMessage"),
              },
              openErrorDialog: true,
            });
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  handleCancelClose = () => {
    this.setState({ openCancelDialog: false });
  };
  closeErrorDialog = () => {
    this.setState({ openErrorDialog: false });
  };

  updateRegistrationData = (
    registrationNumber,
    acceptedDateFce,
    acceptedDateSap,
    vin,
    paymentType
  ) => {
    this.props.hideOrShow(true);
    const proposalNumber =
      this.state.customerReservationDetails &&
      this.state.customerReservationDetails.customerReservation &&
      this.state.customerReservationDetails.customerReservation.proposalNumber;
    const registrationDataRequest = {
      vehicleRegistrationDate: acceptedDateFce,
      vehicleRegistrationMark: registrationNumber,
      vehicleIdentificationNumber: vin,
    };
    CustomerReservationsClient.updateRegistrationNumber(
      this.props.user,
      proposalNumber,
      acceptedDateSap,
      registrationDataRequest,
      this.props.reservationId,
      paymentType,
      this.state.customerReservationDetails.customerReservation.dealerId
    )
      .then(() => {
        this.fetchCustomerOrderDetails();
      })
      .catch((error) => logMsg("the error is: ", error))
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  fetchCustomerOrderDetails() {
    this.props.hideOrShow(true);
    this.setState({ fetchFailed: false });
    const market = this.props.fromCrc ? this.props.selectedMarket : null;
    CustomerReservationsClient.getCustomerOrderDetails(
      this.props.user,
      this.props.reservationId,
      this.props.commonId,
      this.props.fromCrc,
      this.props.lang,
      market
    )
      .then((result) => {
        this.setTradeInDetails(result);
        this.setState({
          customerReservationDetails: result,
          isLoading: false,
        });
        this.fetchCancelReason();
      })
      .catch((error) => {
        this.setState({
          fetchFailed: true,
          isLoading: false,
        });
        logMsg("the error is: ", error);
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  }

  fetchCancelReason = () => {
    let message = "";
    const statusCode =
      this.state.customerReservationDetails.customerReservation
        .cancelStatusCode;
    if (statusCode) {
      switch (UpperCaseText(statusCode)) {
        case "ORDER_CANCELLED":
          message = "CustomerReservations.refundSuccessfulZeroDownPayment";
          break;
        case "ORDER_CANCELLED_REFUND_SUCCESS":
          message = "CustomerReservations.refundSuccessful";
          break;
        case "ORDER_CANCELLED_REFUND_FAILED":
          message = "Error.refundFailure";
          break;
        default:
          message = "";
      }
    }
    this.setState({
      cancellationMessage: {
        body: this.props.t(message),
      },
    });
  };

  fetchLatestOrderUpdateNotifications = (user, orderId) => {
    OrderNotificationsClient.getLatestOrderUpdateNotifications(
      user,
      orderId
    ).then((result) =>
      this.setState({
        latestOrderUpdateNotifications: result.data,
      })
    );
  };

  getSubNav() {
    return (
      <SubNav
        dashboard={false}
        title={this.props.t("CustomerOrderDetails.orderDetail")}
        restrictDropdown={true}
        {...this.props}
      />
    );
  }

  showCancelConfirmationPopup = () => {
    this.setState({ openCancelDialog: true });
  };

  showErrorPopup = (title, bodyText) => {
    this.setState({
      cancellationMessage: {
        title: title,
        body: bodyText,
      },
      openErrorDialog: true,
    });
  };

  isOrderCancelled = (status) => {
    return (
      status === "DEALER_CANCELLED" ||
      status === "RESERVATION_CANCELLED" ||
      status === "CONTRACT_CANCELLED" ||
      status === "ORDER_CANCELLED" ||
      status === "CONTRACT_CANCEL_REQUESTED"
    );
  };

  isReservation = (orderType) => {
    return UpperCaseText(orderType) === "RESERVATION";
  };

  isOrderAccepted = (customerReservation) => {
    // for cash payment
    const hasAcceptedCashOrder =
      customerReservation.acceptTheOrderData &&
      customerReservation.acceptTheOrderData.dealerAcceptedDate &&
      customerReservation.acceptTheOrderData.dealerActionUserId;

    // for other payments(Finance, Lease, Offline Finance, ...)
    const hasApprovedOrder =
      customerReservation.paymentDescription.filter(
        (payment) => payment.status === APPROVED
      ).length > 0;

    if (customerReservation.paymentType !== null) {
      if (UpperCaseText(customerReservation.paymentType).includes("CASH")) {
        return !!hasAcceptedCashOrder;
      } else {
        return hasApprovedOrder;
      }
    } else {
      return false;
    }
  };

  getOrderType = (dealerType) => {
    if (NULL_OR_UNDEFINED(dealerType)) {
      return this.props.t("CustomerOrderDetails.dealer");
    }
    switch (dealerType) {
      case DEALER:
        return this.props.t("CustomerOrderDetails.dealer");
      case AGENT:
        return this.props.t("CustomerOrderDetails.agent");
      default:
        return this.props.t("CustomerOrderDetails.dealer");
    }
  };

  parseBoolean = (value) => {
    if (value === "false" || value === false) {
      return this.props.t("GeneralEMP.statusNo");
    } else if (value === "true" || value === true) {
      return this.props.t("GeneralEMP.statusYes");
    } else {
      return value;
    }
  };

  setTradeInDetails(customerReservationDetails) {
    // If dealer has made changes, take SAP valuation
    const tradeIn =
      customerReservationDetails && customerReservationDetails.tradeIn;
    if (!NULL_OR_UNDEFINED(tradeIn)) {
      // For orders updated offline (will have acceptedDate) use SAP values - valuationAmount, offlineREmainingBalance
      if (!NULL_OR_UNDEFINED(tradeIn.acceptedDate)) {
        this.setState({
          appraisalAmount: this.formatPrice(tradeIn.valuationAmount),
          outstandingFinance: this.formatPrice(tradeIn.offlineRemainingBalance),
        });
      } else {
        IS_GERMAN_MARKET(this.props.selectedMarket)
          ? this.setState({
              appraisalAmount: this.formatPrice(tradeIn.appraisalEstimate),
              outstandingFinance: this.formatPrice(tradeIn.remainingBalance),
            })
          : this.setState({
              appraisalAmount: this.formatPrice(tradeIn.appraisalAmount),
              outstandingFinance: this.formatPrice(tradeIn.remainingBalance),
            });
      }
    }
  }

  isCommercialOrder(segment) {
    return segment === COMMERCIAL_SEGMENT;
  }

  removeDocumentNotifications = (type) => {
    const existing = this.state.latestOrderUpdateNotifications.find(
      (notification) => notification.documentName === type
    );
    if (!NULL_OR_UNDEFINED(existing)) {
      OrderNotificationsClient.deleteNotification(
        this.props.user,
        existing.id
      ).finally(() => {
        this.fetchLatestOrderUpdateNotifications(
          this.props.user,
          this.props.reservationId
        );
      });
    }
    this.fetchCustomerOrderDetails();
  };

  formatPrice(value) {
    return formatEUPriceValue(value, "", "--", true);
  }

  render() {
    if (this.state.isLoading) {
      return this.getSubNav();
    } else if (this.state.fetchFailed) {
      return (
        <div className={styles.errorText}>
          <h2>{this.props.t("FetchError.errorText")}</h2>
        </div>
      );
    } else {
      const customerReservationDetails = this.state.customerReservationDetails;
      const customerReservation =
        customerReservationDetails &&
        customerReservationDetails.customerReservation;
      const tradeIn =
        customerReservationDetails && customerReservationDetails.tradeIn;
      const customerInfo =
        customerReservationDetails && customerReservationDetails.customerInfo;
      const dealerInfo =
        customerReservationDetails && customerReservationDetails.dealerInfo;
      const handOverComplete =
        customerReservation.handoverappointmentConfirmedData &&
        customerReservation.handoverappointmentConfirmedData
          .appointmentInfoData &&
        customerReservation.handoverappointmentConfirmedData.appointmentInfoData.filter(
          (appointment) =>
            appointment.appointmentStatus === HANDOVER_STATUS.RECEIVED
        ).length > 0;

      const dealerType =
        customerReservationDetails &&
        customerReservationDetails.customerReservation &&
        customerReservationDetails.customerReservation.dealerType;

      const paymentType = customerReservation.paymentType;

      // for Hercules, all orders are cash - hiding the payment stack for now
      const showPaymentDetails = this.userAgentHercules
        ? false
        : LowerCaseText(paymentType) === FINANCE ||
          LowerCaseText(paymentType) === PRIVATE_LEASE;

      const handOverExpired = customerReservation.cancelTimeframeExpired;

      const collectionPointMarkets = ["NOR", "ITA"];

      return (
        // eslint-disable-next-line
        <>
          {customerReservation ? (
            <div className="pageWrapper">
              {this.getSubNav()}

              <HasPermissionTo
                perform={["orderDetailsNotifications:view"]}
                permissions={this.props.user.permissions.rolePermissions}
                render={() => (
                  <OrderDetailsActionNotifications
                    {...this.props}
                    customerReservation={customerReservation}
                    tradeIn={tradeIn}
                    isOrderCancelled={this.isOrderCancelled}
                    isReservation={this.isReservation}
                    latestOrderUpdateNotifications={
                      this.state.latestOrderUpdateNotifications
                    }
                  />
                )}
              />

              <BackToSearchResults
                {...this.props}
                herculesCanViewDealerType={this.herculesCanViewDealerType}
                getOrderType={this.getOrderType}
                dealerType={dealerType}
                customerReservation={customerReservation}
                showOrderId={true}
              />
              <div
                className={`customerOrderDetails ${styles.componentContainer}`}
              >
                <OrderInfo
                  customerReservation={customerReservation}
                  consumerType={
                    customerInfo && customerInfo.consumerType
                      ? customerInfo.consumerType
                      : ""
                  }
                  user={this.props.user}
                  market={this.props.selectedMarket}
                  defaultCurrency={
                    this.props.localizedInfo &&
                    this.props.localizedInfo.defaultCurrency &&
                    this.props.localizedInfo.defaultCurrency.symbol
                  }
                />

                <HasPermissionTo
                  perform={["progressTracker:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  render={() => {
                    return (
                      <ProgressTracker
                        isEU={true}
                        reservation={customerReservation}
                        preOrderPlacedStatuses={this.preOrderPlacedStatuses}
                        market={this.props.selectedMarket}
                        message={this.state.cancellationMessage}
                        dealerType={dealerType}
                      />
                    );
                  }}
                />

                <CustomerInfo
                  {...this.props}
                  customerInfoData={customerInfo}
                  user={this.props.user}
                  customerReservation={customerReservation}
                  refreshOrderDetails={this.fetchCustomerOrderDetails}
                />
                {(this.props.fromCrc ||
                  collectionPointMarkets.includes(
                    UpperCaseText(this.props.selectedMarket)
                  )) && (
                  <DealerInformation
                    {...this.props}
                    isNAMarket={false}
                    dealerType={dealerType}
                    dealerInfos={dealerInfo}
                  />
                )}
                {this.userAgentHercules ? (
                  this.isCommercialOrder(customerReservation.segment) ? (
                    <CvVehicleSpecsHercules
                      {...this.props}
                      customerInfoData={customerInfo}
                      defaultCurrency={
                        this.props.localizedInfo.defaultCurrency.symbol
                      }
                      offlinePricingUpdate={
                        customerReservation.offlinePricingUpdate
                          ? customerReservation.offlinePricingUpdate
                          : {}
                      }
                      customerReservationStatus={customerReservation.status}
                      pricingStack={customerReservation.pricingStack}
                      tradeIn={tradeIn}
                      nameplate={customerReservation.nameplate}
                    />
                  ) : (
                    <VehicleSpecsHercules
                      {...this.props}
                      customerInfoData={customerInfo}
                      defaultCurrency={
                        this.props.localizedInfo.defaultCurrency.symbol
                      }
                      offlinePricingUpdate={
                        customerReservation.offlinePricingUpdate
                          ? customerReservation.offlinePricingUpdate
                          : {}
                      }
                      customerReservationStatus={customerReservation.status}
                      pricingStack={customerReservation.pricingStack}
                      allAccessories={customerReservation.allAccessories}
                      tradeIn={tradeIn}
                      appraisalAmount={this.state.appraisalAmount}
                      outstandingFinance={this.state.outstandingFinance}
                      nameplate={customerReservation.nameplate}
                    />
                  )
                ) : (
                  <VehicleSpecs
                    {...this.props}
                    customerInfoData={customerInfo}
                    defaultCurrency={
                      this.props.localizedInfo.defaultCurrency.symbol
                    }
                    offlinePricingUpdate={
                      customerReservation.offlinePricingUpdate
                        ? customerReservation.offlinePricingUpdate
                        : {}
                    }
                    catalogId={customerReservation.catalogId}
                    customerReservationStatus={customerReservation.status}
                    pricingStack={customerReservation.pricingStack}
                    appraisalAmount={this.state.appraisalAmount}
                    nameplate={customerReservation.nameplate}
                    deliveryCostOnOffCost={
                      customerReservation.deliveryCostOnOffCost
                    }
                  />
                )}

                <HasPermissionTo
                  perform={["paymentMethod:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  condition={!this.isReservation(customerReservation.orderType)}
                  render={() => {
                    return (
                      <PaymentMethod
                        {...this.props}
                        removeDocNotifications={
                          this.removeDocumentNotifications
                        }
                        dealerType={dealerType}
                        isOrderCancelled={this.isOrderCancelled}
                        handleUpdatePaymentMethod={
                          this.handleUpdatePaymentMethod
                        }
                        handOverComplete={handOverComplete}
                        updateRegistrationData={this.updateRegistrationData}
                        handleUpdateOrder={this.handleUpdateOrder}
                        refreshOrderDetails={this.fetchCustomerOrderDetails}
                        showErrorPopup={this.showErrorPopup}
                        customerReservation={customerReservation}
                        defaultCurrency={
                          this.props.localizedInfo.defaultCurrency.symbol
                        }
                        overlay={styles.overlay}
                      />
                    );
                  }}
                />

                <HasPermissionTo
                  perform={["customerOptOffline:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  condition={!this.isReservation(customerReservation.orderType)}
                  render={() => {
                    return (
                      <CustomerOptOffline
                        {...this.props}
                        handleCustomerOptOffline={this.handleUpdateOrder}
                        offlineDocInfo={
                          customerReservation.offlineDocInfo
                            ? customerReservation.offlineDocInfo
                            : {}
                        }
                        isOrderCancelled={this.isOrderCancelled(
                          customerReservation.status
                        )}
                        customerReservation={customerReservation}
                        offlinePricingUpdate={
                          customerReservation.offlinePricingUpdate
                            ? customerReservation.offlinePricingUpdate
                            : {}
                        }
                        overlay={styles.overlay}
                      />
                    );
                  }}
                />

                <HasPermissionTo
                  perform={["paymentDetails:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  condition={!this.isReservation(customerReservation.orderType)}
                  render={() => {
                    return (
                      showPaymentDetails && (
                        <PaymentDetails
                          {...this.props}
                          customerReservation={customerReservation}
                          tradeInDetails={tradeIn}
                          customerInfo={customerInfo}
                        />
                      )
                    );
                  }}
                />

                <HasPermissionTo
                  perform={["wallboxOrderDetails:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  condition={
                    !this.isReservation(customerReservation.orderType) &&
                    customerReservation.chargingInstallationRequestDate
                  }
                  render={() => {
                    return (
                      <WallBoxDetails
                        user={this.props.user}
                        isOrderCancelled={this.isOrderCancelled}
                        customerReservation={customerReservation}
                        overlay={styles.overlay}
                      />
                    );
                  }}
                />

                <HasPermissionTo
                  perform={["tradeIn:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  condition={
                    !this.isReservation(customerReservation.orderType) &&
                    tradeIn
                  }
                  render={() => {
                    return (
                      <TradeIn
                        {...this.props}
                        parseBoolean={this.parseBoolean}
                        isOrderCancelled={this.isOrderCancelled}
                        refreshOrderDetails={this.fetchCustomerOrderDetails}
                        showErrorPopup={this.showErrorPopup}
                        status={customerReservation.status}
                        tradeInDetails={tradeIn}
                        overlay={styles.overlay}
                        appraisalAmount={this.state.appraisalAmount}
                        outstandingFinance={this.state.outstandingFinance}
                      />
                    );
                  }}
                />

                <HandOver
                  {...this.props}
                  isOrderCancelled={this.isOrderCancelled(
                    customerReservation.status
                  )}
                  isOrderAccepted={this.isOrderAccepted(customerReservation)}
                  showErrorPopup={this.showErrorPopup}
                  overlay={styles.overlay}
                  customerReservation={customerReservation}
                  refreshOrderDetails={this.fetchCustomerOrderDetails}
                  dealerType={dealerType}
                />
              </div>

              <BackToSearchResults
                {...this.props}
                herculesCanViewDealerType={this.herculesCanViewDealerType}
                getOrderType={this.getOrderType}
                dealerType={dealerType}
                customerReservation={customerReservation}
                showOrderId={false}
              />

              <HasPermissionTo
                perform={["cancelOrder:write"]}
                permissions={this.props.user.permissions.rolePermissions}
                condition={
                  !this.isOrderCancelled(customerReservation.status) &&
                  (dealerType === AGENT ? !handOverExpired : !handOverComplete)
                }
                render={() => (
                  <>
                    <div className={styles.buttonDiv}>
                      <button
                        id="cancelOrderBtn"
                        data-testid="cancelOrderBtn"
                        onClick={(e) => this.showCancelConfirmationPopup(e)}
                      >
                        {this.props.t("CustomerOrderDetails.cancelBtnTxt")}
                      </button>
                    </div>

                    <CancelOrderDialog
                      dialogProps={this.dialogProps}
                      isRefund={false}
                      showDropdown={true}
                      open={this.state.openCancelDialog}
                      onClose={this.handleCancelClose}
                      handleConfirm={this.handleUpdateOrder}
                      {...this.props}
                    />
                  </>
                )}
              />
              <ErrorProcessingDialog
                open={this.state.openErrorDialog}
                close={this.closeErrorDialog}
                title={this.state.cancellationMessage.title}
                body={this.state.cancellationMessage.body}
              />
            </div>
          ) : (
            <>
              {this.getSubNav()}
              <div className="pagePadding">
                {this.props.t("CustomerOrderDetails.errorLoadingDetails")}
              </div>
            </>
          )}
        </>
      );
    }
  }
}

export default withTranslation("emp")(OrderDetailsNewVersion);
